<template>
  <div class="page-shell case-library-page digit-tech-page">
    <el-dialog :visible.sync="showDetail" :title="currentService?.title || ''" width="600px" :close-on-click-modal="false">
      <div v-if="currentService" class="detail-content">
      <div class="detail-icon"><i :class="currentService.icon"></i></div>
      <div class="detail-desc">{{ currentService.detail }}</div>
      <div class="detail-features">
        <h4>核心功能</h4>
        <ul>
          <li v-for="(feature, idx) in currentService.features" :key="idx">{{ feature }}</li>
        </ul>
      </div>
      <div class="detail-tags">
        <span v-for="tag in currentService.tags" :key="tag">{{ tag }}</span>
      </div>
    </div>
  </el-dialog>
  <el-dialog :visible.sync="showTechModal" title="全栈研发技术能力" width="620px" :close-on-click-modal="true">
    <div class="tech-content">
      <div class="tech-section">
        <h4>① 研发团队实力</h4>
        <p>公司核心研发团队自2017年启动数字化软件自研工作，深耕行业数字化开发9年，同步覆盖消防三维仿真、抖音生态小程序两大开发赛道，具备企业级软件独立交付能力；团队长达9年持续深耕消防应急场景数字化开发，深度匹配行业真实业务需求。</p>
      </div>
      <div class="tech-section">
        <h4>② 抖音小程序专属技术栈</h4>
        <p><strong>前端：</strong>抖音原生小程序、uni-app框架，完整支持短视频挂载、团购核销、私信线索收集等平台专属组件；</p>
        <p><strong>后端：</strong>Java SpringBoot开发，深度对接抖音开放平台授权、支付、线索数据回调全套官方API接口。</p>
      </div>
      <div class="tech-section">
        <h4>③ 一站式代开发交付全流程</h4>
        <div class="tech-flow">
          <span>需求沟通</span>
          <span class="flow-arrow">→</span>
          <span>原型UI设计</span>
          <span class="flow-arrow">→</span>
          <span>全功能开发合规测试</span>
          <span class="flow-arrow">→</span>
          <span>抖音平台资质协助配置</span>
          <span class="flow-arrow">→</span>
          <span>小程序上线发布</span>
          <span class="flow-arrow">→</span>
          <span>长期售后迭代运维</span>
        </div>
      </div>
      <div class="tech-section">
        <h4>④ 合规与售后保障</h4>
        <p>严格遵循抖音开放平台管理规范，协助客户完成小程序类目报备；上线后提供长期bug修复、平台接口同步更新服务，完整交付项目源码与部署文档。</p>
      </div>
    </div>
  </el-dialog>
  <section class="case-hero">
      <div class="hero-grid-bg"></div>
      <div class="hero-glow hero-glow-l"></div>
      <div class="hero-glow hero-glow-r"></div>
      <div class="hero-inner">
        <div class="hero-copy">
          <div class="hero-eyebrow">
            <span class="eyebrow-dot"></span>
            Digital Development
          </div>
          <h1>数字化开发技术服务</h1>
          <p class="hero-sub">全栈软件定制・抖音小程序代开发服务商</p>
          <p class="hero-desc">公司2016年完成工商注册，2017年组建专职软件研发团队深耕消防数字化赛道，累计9年技术研发与行业落地经验；一站式交付抖音商家小程序、消防科普小程序、三维仿真软件；具备完整抖音开放平台接口开发、上线运维能力。</p>
          <div class="hero-actions">
            <button class="btn-primary" @click="scrollToList">
              <i class="el-icon-collection"></i>查看服务
            </button>
            <button class="btn-ghost btn-tech" @click="showTechModal = true">
              <i class="el-icon-s-tools"></i>技术能力
            </button>
          </div>
        </div>
        <div class="hero-panel">
          <div class="hp-header">
            <span class="hp-dot"></span>服务能力指标
          </div>
          <div class="hp-metrics">
            <div class="hp-metric-item">
              <span class="hp-metric-label">服务品类</span>
              <strong class="hp-metric-val">4</strong>
            </div>
            <div class="hp-divider"></div>
            <div class="hp-metric-item">
              <span class="hp-metric-label">研发年限</span>
              <strong class="hp-metric-val">9</strong>
            </div>
          </div>
          <div class="hp-status-list">
            <div class="hp-status-row" v-for="s in panelStatus" :key="s.name">
              <span :class="['hp-status-dot', s.dotClass]"></span>
              <span class="hp-status-name">{{ s.name }}</span>
              <span class="hp-status-tag">{{ s.tag }}</span>
            </div>
          </div>
          <div class="hp-tags">
            <span>抖音小程序</span>
            <span>消防数字化</span>
            <span>商家私域</span>
          </div>
        </div>
      </div>
    </section>
    <section class="page-container" ref="serviceList">
      <div class="library-toolbar">
        <div class="toolbar-inner">
          <div class="search-box">
            <i class="el-icon-search search-icon"></i>
            <input v-model="keyword" placeholder="搜索服务名称" class="search-input" />
            <button v-if="keyword" @click="keyword = ''" class="search-clear" type="button">
              <i class="el-icon-close"></i>
            </button>
          </div>
          <div class="category-tabs">
            <button v-for="category in categories" :key="category" :class="['cat-btn', { 'cat-btn--active': activeCategory === category }]" @click="activeCategory = category">
              {{ category }}
            </button>
          </div>
        </div>
      </div>
      <div class="list-header">
        <div class="list-header-left">
          <span class="section-kicker">Tech Services</span>
          <h2 class="list-title">服务列表</h2>
          <p class="list-desc">共 {{ filteredServices.length }} 项服务，点击卡片查看详情。</p>
        </div>
        <div class="list-count-badge">
          <span class="lcb-label">全部服务</span>
          <strong class="lcb-num">{{ filteredServices.length }}</strong>
        </div>
      </div>
      <div v-if="filteredServices.length" class="case-grid">
        <article class="case-card" v-for="(service, index) in filteredServices" :key="service.title" @click="handleDetail(service)">
          <div class="card-cover">
            <div class="cover-fallback">
              <div class="fallback-icon-wrap">
                <i :class="service.icon"></i>
              </div>
              <span class="fallback-label">{{ service.category }}</span>
              <div class="fallback-grid"></div>
            </div>
            <div class="cover-mask"></div>
            <span class="tag-type">{{ service.category }}</span>
            <span :class="['tag-status', service.isHot ? 'tag-status--hot' : 'tag-status--normal']">
              {{ service.isHot ? '主推' : '常规' }}
            </span>
          </div>
          <div class="card-body">
            <h3 class="card-title">{{ service.title }}</h3>
            <p class="card-desc">{{ service.desc }}</p>
            <div class="card-tags">
              <span v-for="tag in service.tags" :key="tag">{{ tag }}</span>
            </div>
            <div class="card-action">
              <span>了解详情</span>
              <i class="el-icon-right"></i>
            </div>
          </div>
          <div class="card-glow-bar"></div>
        </article>
      </div>
      <div v-else class="empty-state">
        <div class="empty-icon-wrap">
          <i class="el-icon-folder-opened"></i>
        </div>
        <h3>暂无匹配服务</h3>
        <p>可尝试清空搜索条件或切换分类。</p>
        <button class="btn-ghost" @click="keyword = ''; activeCategory = '全部服务'">
          <i class="el-icon-refresh"></i>重置筛选
        </button>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Dev",
  data() {
    return {
      keyword: "",
      activeCategory: "全部服务",
      categories: ["全部服务", "抖音商家小程序", "消防科普数字化", "政企管理系统", "三维仿真定制"],
      panelStatus: [
        { name: "抖音小程序全栈交付", tag: "已就绪", dotClass: "dot-green" },
        { name: "消防数字化自研落地", tag: "运行中", dotClass: "dot-blue" },
        { name: "长期迭代运维", tag: "持续服务", dotClass: "dot-orange" },
      ],
      showDetail: false,
      showTechModal: false,
      currentService: null,
      services: [
        {
          title: "商家获客抖音小程序",
          desc: "团购/线索收集/短视频挂载本地门店小程序",
          detail: "严格遵守抖音开放平台开发者管理、用户隐私及内容规范，全程协助客户完成小程序类目资质报备；项目上线后提供长期bug修复、平台接口迭代同步维护，完整交付项目源码、部署与操作文档。",
          features: ["团购套餐创建与核销", "表单线索收集", "短视频挂载门店入口", "订单数据统计", "用户优惠券发放","小程序资质代办、上线与售后运维"],
          category: "抖音商家小程序",
          tags: ["团购核销", "线索获客", "抖音开放平台"],
          icon: "el-icon-shop",
          isHot: true,
        },
        {
          title: "消防应急科普抖音小程序",
          desc: "课程预约、器材商城、隐患上报",
          detail: "专注消防科普领域的抖音小程序，提供在线课程预约、消防器材商城、隐患上报等功能，助力消防知识普及与安全管理。",
          features: ["消防课程在线预约", "应急知识学习", "器材商城", "隐患上报管理", "科普视频推送"],
          category: "消防科普数字化",
          tags: ["应急科普", "预约报名"],
          icon: "el-icon-warning",
          isHot: true,
        },
        {
          title: "政企数字化管理后台",
          desc: "Java定制数据看板、台账系统",
          detail: "基于Java技术栈的政企数字化管理系统，提供数据看板、台账管理、权限控制等功能，支撑政企单位数字化转型。",
          features: ["可视化数据看板", "业务台账管理", "多级权限控制", "流程审批", "报表导出"],
          category: "政企管理系统",
          tags: ["后台系统", "权限管理"],
          icon: "el-icon-data-board",
          isHot: false,
        },
        {
          title: "消防VR仿真培训系统",
          desc: "自有核心业务，大型三维软件交付",
          detail: "基于自研三维引擎的消防VR仿真培训系统，支持沉浸式训练、场景还原、操作考核等功能，提升消防人员实战能力。",
          features: ["VR沉浸式训练", "三维场景还原", "模拟操作考核", "训练数据记录", "多场景切换"],
          category: "三维仿真定制",
          tags: ["VR仿真", "应急训练"],
          icon: "el-icon-videocam",
          isHot: false,
        },
      ],
    };
  },
  computed: {
    filteredServices() {
      const kw = this.keyword.trim().toLowerCase();
      return this.services.filter((s) => {
        const text = `${s.title}${s.desc}`.toLowerCase();
        if (kw && !text.includes(kw)) return false;
        return this.activeCategory === "全部服务" || s.category === this.activeCategory;
      });
    },
  },
  methods: {
    scrollToList() {
      if (this.$refs.serviceList) {
        this.$refs.serviceList.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    handleDetail(service) {
      this.currentService = service;
      this.showDetail = true;
    },
  },
};
</script>

<style scoped lang="scss">
.digit-tech-page {
  --bd: #081c42; --bm: #1557d8; --ba: #1e9bff; --cyan: #20c8ff; --gray: #475569; --gray-s: #64748b;
  --card-bg: rgba(255,255,255,0.92); --card-bdr: rgba(168,199,245,0.68);
  background: radial-gradient(ellipse at 8% 0%, rgba(32,200,255,0.10), transparent 30%), radial-gradient(ellipse at 90% 6%, rgba(47,111,237,0.13), transparent 32%), linear-gradient(180deg, #f2f7ff 0%, #f5f8fd 48%, #ffffff 100%);
}
.page-shell { overflow: hidden; }
.page-container { width: min(1400px, calc(100% - 48px)); margin: 0 auto; padding: 48px 0 72px; }

.case-hero { position: relative; padding: 52px 0 44px; overflow: hidden; }
.hero-grid-bg { position: absolute; inset: 0; opacity: 0.44; background-image: linear-gradient(rgba(47,111,237,0.08) 1px, transparent 1px), linear-gradient(90deg, rgba(47,111,237,0.08) 1px, transparent 1px); background-size: 46px 46px; mask-image: linear-gradient(180deg, rgba(0,0,0,0.85), transparent 94%); pointer-events: none; }
.hero-glow { position: absolute; border-radius: 50%; filter: blur(16px); pointer-events: none; }
.hero-glow-l { width: 420px; height: 420px; left: -140px; bottom: -140px; background: rgba(21,87,216,0.10); }
.hero-glow-r { width: 280px; height: 280px; right: 4%; top: 4%; background: rgba(32,200,255,0.10); }

.hero-inner { position: relative; z-index: 1; width: min(1400px, calc(100% - 48px)); margin: 0 auto; display: grid; grid-template-columns: 1fr 300px; gap: 36px; align-items: end; }
.hero-eyebrow { display: inline-flex; align-items: center; gap: 8px; padding: 5px 12px; border-radius: 999px; background: rgba(21,87,216,0.09); color: var(--bm); font-size: 12px; font-weight: 800; letter-spacing: 0.4px; margin-bottom: 16px; }
.eyebrow-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--cyan); box-shadow: 0 0 0 4px rgba(32,200,255,0.20), 0 0 12px rgba(32,200,255,0.7); }
.hero-copy h1 { margin: 0 0 10px; color: var(--bd); font-size: clamp(28px, 3.4vw, 44px); font-weight: 950; line-height: 1.1; letter-spacing: -0.8px; }
.hero-sub { color: var(--bm); font-size: 13px; font-weight: 700; letter-spacing: 1.2px; opacity: 0.82; margin-bottom: 8px; }
.hero-desc { max-width: 600px; color: var(--gray); font-size: 14px; line-height: 1.82; }

.hero-actions { display: flex; gap: 12px; margin-top: 22px; flex-wrap: wrap; }
.btn-primary, .btn-ghost { height: 38px; padding: 0 18px; border-radius: 999px; border: none; cursor: pointer; display: inline-flex; align-items: center; gap: 7px; font-size: 13px; font-weight: 800; transition: all 0.22s ease; }
.btn-primary { color: #fff; background: linear-gradient(135deg, #1248c8, var(--ba) 62%, var(--cyan)); box-shadow: 0 10px 24px rgba(21,87,216,0.24); }
.btn-primary:hover { transform: translateY(-2px); box-shadow: 0 14px 30px rgba(21,87,216,0.32); }
.btn-ghost { color: var(--bd); background: rgba(255,255,255,0.86); border: 1px solid rgba(21,87,216,0.16); backdrop-filter: blur(10px); }
.btn-ghost:hover { transform: translateY(-2px); border-color: var(--ba); }

.hero-panel { position: relative; padding: 20px; border-radius: 20px; background: linear-gradient(150deg, rgba(8,22,58,0.96), rgba(10,52,112,0.92)); border: 1px solid rgba(32,200,255,0.20); color: #fff; box-shadow: 0 24px 52px rgba(4,14,44,0.20); overflow: hidden; }
.hero-panel::after { content: ""; position: absolute; right: -50px; top: -50px; width: 150px; height: 150px; border-radius: 50%; background: rgba(32,200,255,0.14); filter: blur(4px); pointer-events: none; }
.hp-header { display: flex; align-items: center; gap: 7px; font-size: 11px; font-weight: 800; color: rgba(255,255,255,0.65); margin-bottom: 16px; letter-spacing: 0.3px; }
.hp-dot { width: 6px; height: 6px; border-radius: 50%; background: var(--cyan); box-shadow: 0 0 8px rgba(32,200,255,0.9); }
.hp-metrics { display: flex; align-items: center; gap: 12px; margin-bottom: 16px; padding-bottom: 16px; border-bottom: 1px solid rgba(255,255,255,0.09); }
.hp-metric-item { flex: 1; text-align: center; }
.hp-metric-label { display: block; font-size: 11px; color: rgba(255,255,255,0.60); margin-bottom: 4px; font-weight: 700; }
.hp-metric-val { font-size: 28px; font-weight: 950; color: #fff; line-height: 1; }
.hp-divider { width: 1px; height: 40px; background: rgba(255,255,255,0.12); }
.hp-status-list { display: flex; flex-direction: column; gap: 8px; margin-bottom: 16px; }
.hp-status-row { display: flex; align-items: center; gap: 8px; font-size: 12px; }
.hp-status-dot { width: 6px; height: 6px; border-radius: 50%; flex-shrink: 0; }
.dot-green { background: #4ade80; box-shadow: 0 0 6px rgba(74,222,128,0.8); }
.dot-blue { background: #60a5fa; box-shadow: 0 0 6px rgba(96,165,250,0.8); }
.dot-orange { background: #fbbf24; box-shadow: 0 0 6px rgba(251,191,36,0.8); }
.hp-status-name { flex: 1; color: rgba(255,255,255,0.82); }
.hp-status-tag { color: rgba(255,255,255,0.46); font-size: 11px; }
.hp-tags { display: flex; flex-wrap: wrap; gap: 6px; padding-top: 14px; border-top: 1px solid rgba(255,255,255,0.09); }
.hp-tags span { padding: 4px 9px; border-radius: 999px; color: #c4f0ff; background: rgba(255,255,255,0.08); font-size: 11px; font-weight: 800; border: 1px solid rgba(255,255,255,0.10); }

.library-toolbar { margin-bottom: 24px; padding: 16px 20px; border-radius: 18px; background: rgba(255,255,255,0.90); border: 1px solid var(--card-bdr); box-shadow: 0 10px 28px rgba(8,28,66,0.07); backdrop-filter: blur(12px); }
.toolbar-inner { display: grid; grid-template-columns: minmax(240px, 400px) 1fr; gap: 16px; align-items: center; }
.search-box { height: 40px; display: flex; align-items: center; gap: 9px; padding: 0 12px; border-radius: 12px; background: #f4f8fe; border: 1px solid rgba(21,87,216,0.12); transition: border-color 0.2s; }
.search-box:focus-within { border-color: var(--ba); box-shadow: 0 0 0 3px rgba(30,155,255,0.10); }
.search-icon { color: var(--ba); font-size: 16px; flex-shrink: 0; }
.search-input { flex: 1; border: none; outline: none; background: transparent; color: var(--bd); font-size: 13px; }
.search-clear { width: 22px; height: 22px; border: none; border-radius: 50%; cursor: pointer; color: var(--gray-s); background: rgba(21,87,216,0.08); display: grid; place-items: center; font-size: 12px; transition: background 0.2s; }
.search-clear:hover { background: rgba(21,87,216,0.16); }
.category-tabs { display: flex; flex-wrap: wrap; gap: 7px; justify-content: flex-end; }
.cat-btn { height: 32px; padding: 0 12px; border: 1px solid rgba(21,87,216,0.14); border-radius: 999px; color: var(--gray); background: transparent; cursor: pointer; transition: all 0.20s ease; font-size: 12px; font-weight: 800; }
.cat-btn:hover { color: var(--bm); border-color: rgba(21,87,216,0.38); background: rgba(21,87,216,0.05); }
.cat-btn--active { color: #fff; background: linear-gradient(135deg, #1248c8, var(--ba)); border-color: transparent; box-shadow: 0 6px 16px rgba(21,87,216,0.20); }

.list-header { display: flex; align-items: center; justify-content: space-between; gap: 20px; margin-bottom: 20px; }
.section-kicker { display: inline-block; margin-bottom: 5px; color: var(--ba); font-size: 11px; font-weight: 800; letter-spacing: 0.5px; }
.list-title { color: var(--bd); font-size: 22px; font-weight: 950; margin: 0 0 4px; line-height: 1.2; }
.list-desc { color: var(--gray-s); font-size: 13px; }
.list-count-badge { min-width: 96px; padding: 12px 14px; border-radius: 16px; text-align: center; background: rgba(255,255,255,0.82); border: 1px solid var(--card-bdr); box-shadow: 0 8px 22px rgba(8,28,66,0.07); }
.lcb-label { display: block; color: var(--gray-s); font-size: 11px; font-weight: 700; margin-bottom: 4px; }
.lcb-num { color: var(--bm); font-size: 26px; font-weight: 950; line-height: 1; }

.case-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 22px; }
.case-card { position: relative; overflow: hidden; border-radius: 18px; background: var(--card-bg); border: 1px solid var(--card-bdr); box-shadow: 0 10px 28px rgba(8,28,66,0.07); cursor: pointer; transition: transform 0.24s ease, box-shadow 0.24s ease, border-color 0.24s ease; }
.case-card:hover { transform: translateY(-6px); box-shadow: 0 24px 56px rgba(8,28,66,0.12); border-color: rgba(30,155,255,0.38); }
.card-glow-bar { position: absolute; top: 0; left: 0; right: 0; height: 2px; background: linear-gradient(90deg, var(--bm), var(--cyan), rgba(32,200,255,0)); opacity: 0; transition: opacity 0.24s ease; }
.case-card:hover .card-glow-bar { opacity: 1; }

.card-cover { position: relative; height: 200px; overflow: hidden; background: linear-gradient(135deg, #e8f0fc, #f4f8ff); }
.cover-fallback { position: relative; height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 10px; overflow: hidden; }
.fallback-grid { position: absolute; inset: 0; background-image: linear-gradient(rgba(21,87,216,0.09) 1px, transparent 1px), linear-gradient(90deg, rgba(21,87,216,0.09) 1px, transparent 1px); background-size: 20px 20px; pointer-events: none; }
.fallback-icon-wrap { position: relative; z-index: 1; width: 56px; height: 56px; border-radius: 18px; display: grid; place-items: center; background: linear-gradient(145deg, rgba(21,87,216,0.14), rgba(32,200,255,0.18)); border: 1px solid rgba(21,87,216,0.18); color: var(--bm); font-size: 26px; box-shadow: 0 10px 26px rgba(21,87,216,0.14); }
.fallback-label { position: relative; z-index: 1; font-size: 13px; font-weight: 800; color: var(--bm); letter-spacing: 0.5px; }
.cover-mask { position: absolute; inset: 0; background: linear-gradient(180deg, transparent 40%, rgba(8,20,52,0.40)); pointer-events: none; }

.tag-type, .tag-status { position: absolute; z-index: 3; border-radius: 999px; font-size: 11px; font-weight: 800; letter-spacing: 0.2px; }
.tag-type { left: 12px; bottom: 12px; padding: 4px 9px; color: #fff; background: rgba(18,72,200,0.90); backdrop-filter: blur(8px); border: 1px solid rgba(255,255,255,0.14); }
.tag-status { right: 12px; top: 12px; padding: 4px 9px; }
.tag-status--hot { color: #fff; background: linear-gradient(135deg, #f97316, #fbbf24); box-shadow: 0 4px 12px rgba(249,115,22,0.28); }
.tag-status--normal { color: #c4f0ff; background: rgba(8,28,66,0.66); border: 1px solid rgba(255,255,255,0.14); backdrop-filter: blur(8px); }

.card-body { padding: 16px 18px 14px; }
.card-title { color: var(--bd); font-size: 16px; font-weight: 900; line-height: 1.38; margin: 0 0 8px; min-height: 44px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
.card-desc { color: var(--gray); font-size: 13px; line-height: 1.72; min-height: 60px; display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; }
.card-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 12px; }
.card-tags span { padding: 3px 8px; border-radius: 999px; color: var(--bm); background: rgba(21,87,216,0.07); border: 1px solid rgba(21,87,216,0.13); font-size: 11px; font-weight: 800; }
.card-action { margin-top: 14px; padding-top: 12px; border-top: 1px solid rgba(226,232,240,0.8); display: flex; justify-content: space-between; align-items: center; color: var(--bm); font-size: 13px; font-weight: 900; transition: color 0.2s; }
.case-card:hover .card-action { color: var(--ba); }

.empty-state { min-height: 260px; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 48px 32px; background: rgba(255,255,255,0.88); border: 1px solid var(--card-bdr); border-radius: 20px; box-shadow: 0 10px 28px rgba(8,28,66,0.06); }
.empty-icon-wrap { width: 64px; height: 64px; border-radius: 20px; display: grid; place-items: center; background: linear-gradient(145deg, rgba(21,87,216,0.10), rgba(32,200,255,0.12)); color: var(--ba); font-size: 28px; margin-bottom: 16px; }
.empty-state h3 { color: var(--bd); font-size: 18px; font-weight: 900; margin-bottom: 8px; }
.empty-state p { color: var(--gray-s); font-size: 13px; line-height: 1.72; margin-bottom: 20px; }

@media (max-width: 1100px) { .case-grid { grid-template-columns: repeat(2, 1fr); } }
@media (max-width: 960px) { .hero-inner, .toolbar-inner { grid-template-columns: 1fr; } .hero-panel { display: none; } .category-tabs { justify-content: flex-start; } }
@media (max-width: 640px) { .case-grid { grid-template-columns: 1fr; } .list-header { display: block; } .list-count-badge { margin-top: 14px; text-align: left; width: fit-content; } .page-container { padding: 32px 0 52px; } .case-hero { padding: 36px 0 30px; } }

.detail-content { padding: 8px 0; }
.detail-icon { width: 64px; height: 64px; border-radius: 18px; display: grid; place-items: center; background: linear-gradient(145deg, rgba(21,87,216,0.14), rgba(32,200,255,0.18)); color: var(--bm); font-size: 32px; margin-bottom: 16px; }
.detail-desc { color: var(--gray); font-size: 14px; line-height: 1.75; margin-bottom: 20px; }
.detail-features h4 { color: var(--bd); font-size: 16px; font-weight: 900; margin-bottom: 12px; }
.detail-features ul { padding-left: 20px; }
.detail-features li { color: var(--gray); font-size: 14px; line-height: 1.8; padding: 4px 0; }
.detail-features li::marker { color: var(--ba); }
.detail-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 16px; padding-top: 16px; border-top: 1px solid rgba(226,232,240,0.8); }
.detail-tags span { padding: 4px 10px; border-radius: 999px; color: var(--bm); background: rgba(21,87,216,0.07); border: 1px solid rgba(21,87,216,0.13); font-size: 12px; font-weight: 800; }

.btn-tech { cursor: pointer; }
.btn-tech:hover { background: rgba(47,111,237,0.08); border-color: var(--ba); transform: translateY(-2px); }

.tech-content { padding: 8px 0; }
.tech-section { margin-bottom: 20px; }
.tech-section:last-child { margin-bottom: 0; }
.tech-section h4 { color: var(--bm); font-size: 15px; font-weight: 900; margin-bottom: 10px; }
.tech-section p { color: var(--gray); font-size: 14px; line-height: 1.8; }
.tech-section p strong { color: var(--bd); }
.tech-flow { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
.tech-flow span { padding: 5px 10px; border-radius: 999px; background: rgba(21,87,216,0.07); color: var(--bm); font-size: 12px; font-weight: 800; }
.tech-flow .flow-arrow { padding: 0; background: transparent; color: var(--ba); font-weight: 400; }
</style>